<template>
    <div class="ui grid">
      <div v-if="(images>0 && (identification>=1 || resembling>=1)) || active_gallery!=0" v-bind:class="galleryClass" style="padding-left:0px">
       <!--   <div v-if="((identification>=1 || resembling>=1)) || active_gallery!=0" v-bind:class="galleryClass" style="padding-left:0px">-->
            <TheGalleryItem v-bind:object="active_gallery_object"></TheGalleryItem>
        </div>
        <div v-if="images>1" v-bind:class="gallerySelectorClass" style="padding-left:0px">
            <div v-if="identification>0" class="ui segment" style="padding:0px">
                <h4 style="margin:0.5rem">Identified Artworks</h4>
                <div v-for="(obj, index) in object_list" :key="obj.xmld_id" v-on:click="openinGallery(index)" style="cursor:pointer;">
                    <div style="width:100%;height:1vh;" v-bind:class="{high:obj.cert=='high',medium:obj.cert=='medium',low:obj.cert=='low'}"></div>
                    <img v-if="obj.relationship_type=='identification'" v-bind:src="'/static/images/'+obj.images[0].file" class="ui fluid image" style="margin-bottom:1vh" v-bind:class="{active_thumb :active_gallery==index}">

                </div>
            </div>
            <div v-if="resembling>0" class="ui segment" style="padding:0px">
                <h4 style="margin:0.5rem">Resembling Objects</h4>
                <div v-for="(obj, index) in object_list" :key="obj.xmld_id" v-on:click="openinGallery(index)" style="cursor:pointer" v-bind:class="{active_thumb :active_gallery==index}">
                    <img v-if="obj.relationship_type=='resembling'" v-bind:src="'/static/images/'+obj.images[0].file" class="ui fluid image" style="margin-bottom:1vh">
                </div>
            </div>

            <div v-if="related>0" class="ui segment" style="padding:0px">
                <h4 style="margin:0.5rem">Related Items</h4>
                <div v-for="(obj, index) in object_list" :key="obj.xmld_id" v-on:click="openinGallery(index)" style="cursor:pointer" v-bind:class="{active_thumb :active_gallery==index}">
                    <img v-if="obj.relationship_type=='related'" v-bind:src="'/static/images/'+obj.images[0].file" class="ui fluid image" style="margin-bottom:1vh">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TheGalleryItem from './TheGalleryItem.vue'
    export default {
        props: ['object_list'],
        data() {
            return {
                slides: [],
                images: 0,
                identification: 0,
                resembling: 0,
                related: 0,
                active_gallery_object: null,
                active_gallery: 0,
                layout: ""

            }
        },
        computed: {
            galleryClass: function() {
                if (this.images > 1) {
                    return { ten: true, wide: true, column: true }
                }
                if (this.images == 1) {
                    return { sixteen: true, wide: true, column: true }
                }
            },
            gallerySelectorClass: function() {
                var layout = {}
                if (this.identification == 0 && this.resembling == 0 && this.active_gallery == 0) {
                    return { sixteen: true, wide: true, column: true }
                }
                if ((!(this.identification == 0 && this.resembling == 0)) || this.active_gallery != 0) {
                    layout.galleryOpened = true
                    layout.gallerySelectorOpened = true;
                    this.layout = JSON.stringify(layout)
                    return { six: true, wide: true, column: true }
                }

            }
        },

        methods: {
            getObjectStatistics: function() {
                for (var i in this.object_list) {
                    if (this.object_list[i].hasOwnProperty('images')) {
                        this.images++;
                    }
                    if (this.object_list[i].hasOwnProperty('relationship_type')) {
                        if (this.object_list[i].relationship_type == "identification") {
                            this.identification++;
                        }
                        if (this.object_list[i].relationship_type == "resembling") {
                            this.resembling++;
                        }
                        if (this.object_list[i].relationship_type == "related") {
                            this.related++;
                        }
                    }
                }
            },

            setActiveGalleryObject: function() {
                for (var i in this.object_list) {
                    if (this.object_list[i].hasOwnProperty('images')) {
                        if (this.object_list[i].relationship_type == "identification") {
                            this.active_gallery_object = this.object_list[i]
                            return 0;
                        }
                    }
                }
                for (var i in this.object_list) {
                    if (this.object_list[i].hasOwnProperty('images')) {
                        if (this.object_list[i].relationship_type == "resembling") {
                            this.active_gallery_object = this.object_list[i]
                            return 0;
                        }
                    }
                }
              //  console.log("Warning: expected identification or resembling with display flag but nothing was found")
            },

            openinGallery: function(index, thumb) {
                this.active_gallery = index;
                this.active_gallery_object = this.object_list[index];
            },

            hasOwnDeepProperty: function(obj, path) {
                var arr;
                for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
                    arr = path[i].match(/(.+)\[(\d+)\]/mi);
                    if (arr != null) {
                        if (arr.length == 3) {
                            if (obj[arr[1]]) obj = obj[arr[1]][arr[2]];
                            else return false;
                        }
                    }
                    else obj = obj[path[i]];
                    if (!obj) return false;
                };
                return true;
            },

            hasOwnDeepPropertyv2: function(obj, path) {
                path = path.split('.');
                for (var i in path) {
                    if (path[i].match(/\[\d+\]/mi) == null) {
                        if (obj.hasOwnProperty(path[i])) {
                            obj = obj[path[i]];
                        }
                        else {
                            return false
                        }
                    }
                    else {
                        var matchArr = path[i].match(/\[(\d+)\]/mi);
                        obj = obj[path[i].replace(/\[\d+\]/mi, '')];
                        console.log(JSON.stringify(obj))
                        if (obj != undefined) {
                            obj = obj[matchArr[1]]
                        }
                        else {
                            return false
                        }
                    }
                }
                return true
            },



        },
        beforeMount() {

        },

        mounted() {
            this.getObjectStatistics();
            this.setActiveGalleryObject();
            var layout = {}
            if (this.images > 1) {
                layout.galleryOpened = true
                layout.gallerySelectorOpened = true;
                this.layout = JSON.stringify(layout)
            }
            if (this.images == 1) {
                layout.galleryOpened = true
                layout.gallerySelectorOpened = false;
                this.layout = JSON.stringify(layout)
            }

            if (this.identification == 0 && this.resembling == 0 && this.related==0) {
                layout.galleryOpened = false
                layout.gallerySelectorOpened = false;
                this.layout = JSON.stringify(layout)
            }
            if (this.identification == 0 && this.resembling == 0 && this.related>0) {
                layout.galleryOpened = false
                layout.gallerySelectorOpened = true;
                this.layout = JSON.stringify(layout)
            }

            console.log("Images: " + this.images + "; Identifications: " + this.identification + "; Resembling: " + this.resembling + "; Related: " + this.related);
        },
        components: {
            TheGalleryItem
        },
        watch: {
            layout: function(n, o) {
              this.$emit('layout', n);
            }

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .italic {
        font-style: italic;
    }

    .active_thumb {
        border-right: 6px solid #1e70bf;
        border-image-outset: 15px;
    }

    .certainty {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        padding: 0.18em 1em;

    }

    .high {
        background-color: rgb(174, 223, 181)
    }

    .medium {
        background-color: rgb(255, 216, 179)
    }

    .low {
        background-color: #FFAAAA
    }

    .placeholder {
        background-color: #b3b3b3
    }

    .certainty_padding {
        padding-top: 3em;
    }

    .gray {
        color: #999999;
    }

    .similar_artwork_xx {
        position: absolute;
        bottom: 1rem;
        text-align: center;
        background-color: rgb(255, 255, 255);
        height: 3rem;
        opacity: 0.7;
        padding: 0.5em;
        width: 100%;

    }
</style>



// WEBPACK FOOTER //
// src/components/TheGallery2.vue